import AvailabilityError from '~/constants/availabilityError';
import PurchaseType from '~/constants/purchaseType';
import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useIsReservableVehicle() {
  const { purchaseType } = useGetVehicleDetails();
  const { error } = useVehicleAvailability();

  return (
    purchaseType === PurchaseType.Reservable ||
    error === AvailabilityError.UnavailableReserved
  );
}
